
export default class UtilsSpinner {

  get spinner() { return this._spinner; }
  set spinner(value) { this._spinner = value; }

  constructor() {

  }

  spin(target) {
    this.target = target;
    if($(this.target).hasClass('position-relative') == false){
      $(this.target).addClass('position-relative');
    }
    kendo.ui.progress($(this.target), true);
  }

  stop() {
    kendo.ui.progress($(this.target), false);
    $(this.target).removeClass('position-relative');
  }
}
